/**
 * @file 适配新NMP接口返回的结果
 * @author feibinyang
 */

import {isUndefined} from 'lodash';
import IO from '../io/IO';
import {purify} from './lang';

/**
 * 后端返回的结果代码对应的类型
 *
 * @const {string}
 *
 * eslint-disable Pascal-case
 */
const CODE_TYPE = {
    0: 'SUCCESS',
    1: 'GLOBAL',
    2: 'FIELD',
    3: 'REDIRECT',
    4: 'NO_SESSION'
};

/**
 * 最小的自定义错误代码
 * 小于此代码的均保留为预定义类型，大于等于此代码作为自定义处理
 *
 * @const {number}
 */
const MINIMAL_CUSTOM_FAIL_CODE = 100;

/**
 * 适配新NMP接口返回的结果
 *
 * @public
 * @param {Object} data 后端返回的数据对象
 * @return {Object} 转换过后符合前端逻辑的对象
 */
export default function prepareResponse(data) {
    if (!isUndefined(data.code)) { // 有code时认为是新版接口
        let status = CODE_TYPE[data.code];

        if (!status) {
            if (data.code < MINIMAL_CUSTOM_FAIL_CODE) { // 非预定义类型，未知错误
                return IO.UNKNOWN_ERROR;
            }

            // 自定义类型错误
            let message = data.message || {};
            message.code = data.code;
            return {
                success: false,
                message: message
            };
        }

        if (status === 'SUCCESS') {
            let result = {
                success: true,
                message: data.message,
                result: data.result || data.page
            };

            return purify(result);
        }

        return {
            success: false,
            message: data.message
        };
    }

    if (!isUndefined(data.success)) {
        return data;
    }

    return IO.SCHEMA_ERROR;
}
